Icon
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_18747_9643)">
      <path
        d="M8.75318 7.97821V6.56592C8.75318 6.44697 8.79781 6.35772 8.90183 6.29832L11.7413 4.66306C12.1279 4.44009 12.5888 4.33607 13.0644 4.33607C14.8483 4.33607 15.9782 5.71866 15.9782 7.19035C15.9782 7.29437 15.9782 7.41332 15.9632 7.53227L13.0198 5.80776C12.8414 5.70374 12.6629 5.70374 12.4846 5.80776L8.75318 7.97821ZM15.3834 13.4787V10.104C15.3834 9.89582 15.2943 9.7472 15.1159 9.64314L11.3845 7.47272L12.6035 6.77397C12.7076 6.71456 12.7968 6.71456 12.9008 6.77397L15.7403 8.40922C16.558 8.88501 17.108 9.89582 17.108 10.8769C17.108 12.0068 16.4391 13.0475 15.3834 13.4787ZM7.87608 10.5055L6.65706 9.79195C6.55304 9.73257 6.50841 9.64332 6.50841 9.52439V6.25384C6.50841 4.66321 7.72743 3.45897 9.37762 3.45897C10.0021 3.45897 10.5817 3.66716 11.0724 4.03877L8.14381 5.73358C7.96547 5.83761 7.87622 5.98625 7.87622 6.19444L7.87608 10.5055ZM10.5 12.0218L8.75318 11.0407V8.95945L10.5 7.97835L12.2467 8.95945V11.0407L10.5 12.0218ZM11.6224 16.5412C10.9979 16.5412 10.4183 16.333 9.92756 15.9614L12.8562 14.2666C13.0346 14.1626 13.1237 14.0139 13.1237 13.8057V9.49451L14.3577 10.2081C14.4618 10.2674 14.5064 10.3567 14.5064 10.4756V13.7462C14.5064 15.3368 13.2724 16.5412 11.6224 16.5412ZM8.09905 13.2261L5.25955 11.5908C4.44185 11.115 3.89188 10.1042 3.89188 9.12307C3.89188 7.97835 4.57572 6.9526 5.63117 6.52144V9.91089C5.63117 10.1191 5.72041 10.2678 5.89876 10.3718L9.61538 12.5273L8.39634 13.2261C8.29232 13.2854 8.20307 13.2854 8.09905 13.2261ZM7.93563 15.6641C6.25574 15.6641 5.0218 14.4004 5.0218 12.8395C5.0218 12.7206 5.03672 12.6016 5.0515 12.4827L7.98011 14.1775C8.15845 14.2815 8.33694 14.2815 8.51529 14.1775L12.2467 12.0219V13.4343C12.2467 13.5532 12.2021 13.6424 12.098 13.7018L9.2585 15.3371C8.87199 15.5601 8.41127 15.6641 7.93563 15.6641ZM11.6224 17.4331C13.4212 17.4331 14.9226 16.1546 15.2647 14.4598C16.9296 14.0287 18 12.4678 18 10.8771C18 9.83645 17.5541 8.82564 16.7513 8.09715C16.8256 7.78494 16.8702 7.47272 16.8702 7.16065C16.8702 5.03482 15.1457 3.44404 13.1536 3.44404C12.7523 3.44404 12.3658 3.50344 11.9792 3.63731C11.3102 2.98318 10.3884 2.56694 9.37762 2.56694C7.57879 2.56694 6.07739 3.84536 5.73533 5.54017C4.07038 5.97133 3 7.53227 3 9.12289C3 10.1636 3.44594 11.1744 4.24872 11.9029C4.1744 12.2151 4.12977 12.5273 4.12977 12.8394C4.12977 14.9652 5.85428 16.556 7.84638 16.556C8.2477 16.556 8.63424 16.4966 9.02077 16.3627C9.68969 17.0168 10.6114 17.4331 11.6224 17.4331Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_18747_9643">
        <rect
          width="15"
          height="15"
          fill="transparent"
          style="fill:transparent;fill-opacity:1;"
          transform="translate(3 2.5)"
        />
      </clipPath>
    </defs>

  </svg>
</template>

<script>
export default {
  name: 'AltAlertIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>
